import gsap from "gsap";

const initializedSections = new WeakSet<HTMLElement>();

export const initProductHeaderAnimations = (root: ParentNode = document): void => {
  root.querySelectorAll<HTMLElement>(".pr-header").forEach((section) => {
    if (initializedSections.has(section)) return;

    const imageWrap = section.querySelector<HTMLElement>(".pr-header-image-wrap-animate");
    const image = section.querySelector<HTMLImageElement>(".pr-header-image-animate");
    const copy = section.querySelector<HTMLElement>("[data-product-header-copy]");
    const textItems = copy
      ? Array.from(copy.querySelectorAll<HTMLElement>(".pr-header-animate"))
      : [];

    if (!imageWrap || !image || !textItems.length) return;

    initializedSections.add(section);
    gsap.killTweensOf([imageWrap, image, ...textItems]);

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      gsap.set(imageWrap, { autoAlpha: 1, willChange: "auto" });
      gsap.set(image, { autoAlpha: 1, y: 0, scale: 1, willChange: "auto" });
      gsap.set(textItems, { autoAlpha: 1, x: 0, willChange: "auto" });
      return; 
    }

    gsap.set(imageWrap, {
      autoAlpha: 0,
      willChange: "opacity",
    });
    gsap.set(image, {
      autoAlpha: 0,
      y: 48,
      scale: 0.78,
      transformOrigin: "50% 65%",
      willChange: "transform,opacity",
    });
    gsap.set(textItems, {
      autoAlpha: 0,
      x: -60,
      willChange: "transform,opacity",
    });

    let hasPlayed = false;
    const play = (): void => {
      if (hasPlayed) return;
      hasPlayed = true;

      const timeline = gsap.timeline({
        delay: 0.12,
        onComplete: () => {
          imageWrap.classList.remove("pr-header-image-wrap-animate");
          image.classList.remove("pr-header-image-animate");
        },
      });

      timeline
        .to(imageWrap, {
          autoAlpha: 1,
          duration: 0.18,
          ease: "power1.out",
        }, 0)
        .to(image, {
          autoAlpha: 1,
          duration: 0.18,
          ease: "power1.out",
        }, 0)
        .to(image, {
          y: 0,
          scale: 1,
          duration: 0.9,
          ease: "power4.out",
        }, 0)
        .to(textItems, {
          autoAlpha: 1,
          x: 0,
          duration: 0.58,
          stagger: 0.1,
          ease: "power3.out",
        }, 0.18);
    };

    if (image.complete && image.naturalWidth > 0) {
      requestAnimationFrame(play);
      return;
    }

    image.addEventListener("load", play, { once: true });
    image.addEventListener("error", play, { once: true });
  });
};
